
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import CustomerReport from "../components/customerReport";
import Footer from "../components/footer";

function CustomerReportPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <CustomerReport /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default CustomerReportPage;
